import React, { useEffect, useCallback, useState} from 'react';
import {setZObjectTypeDragging} from 'actions/index.js';
import {useContainerCoords} from "components/hooks/useContainerCoords.js";
import {useZObjects} from './useZObjects.js';


export const useZObjectDrop = ({ref, subSequence, setSelection}) => {
    const {
        createPad,
        createSequencer,
        createButton,
        createZNumber,
        createZMessage,
        createToggle,
        createZObject
    } = useZObjects(subSequence);
    let {getXY} = useContainerCoords({containerRef: ref});


    const onDrop = useCallback((e) => {
        let {x,y} = getXY(e);
        let {sequencerEngine} = subSequence;
        let {state} = sequencerEngine;
        let {objectDragging, zobjectTypeDragging} = state.zobject;

        if (objectDragging) {
            subSequence.moveObjectInto(objectDragging, x, y);
            return;
        }

        if (!zobjectTypeDragging) {
            return;
        }

        switch(zobjectTypeDragging) {
        case "zobject":
            createZObject(x,y);
            break;
        case "zmessage":
            createZMessage(x,y);
            break;
        case "zpad":
            createPad(x,y);
            break;
        case "zbutton":
            createButton(x,y);
            break;
        case "ztoggle":
            createToggle(x,y);
            break;
        case "znumber":
            createZNumber(x,y);
            break;
        case "sequencer":
            createSequencer(x,y);
            break;
        case "zcomment":
            createZObject(x,y, "comment");
            break;
        }
        
        sequencerEngine.dispatch(setZObjectTypeDragging(undefined));
        setSelection(undefined);
    }, [subSequence]);

    return {onDrop};
};
 
